export const STRINGS = {
  SIGNUP_HEADING:
    "Hello, if you are a rental vehicle company and wanting to list",
  SIGNUP_SUBHEADING:
    "your vehicles for relocation here, please use the form below",
  SIGNUP_SUB_SUBHEADING:
    "If you are unsure if we are a good fit to your company, please click here for more details",
  SOMETHING_WENT_WRONG: "Something went wrong!",
  RECAPCHA_REQUIRED: "reCAPTCHA required",
  INVALID_RECAPCHA: "reCAPTCHA verification failed.",
  RECAPCHA_VERIFIED: "reCAPTCHA verified",
  RECAPCHA_NOT_VERIFIED: "reCAPTCHA not verified yet.",
  OR_CONNECT_WITH: "Or Connect with",
  EMAIL_INPUT_NAME: "email",
  EMAIL_REQUIRED: "Email is required.",
  PASSWORD_INPUT_NAME: "password",
  NAME_INPUT: "name",
  COUNTRY_INPUT: "country",
  CITY_INPUT: "city",
  SURNAME_INPUT: "surname",
  SURNAME_PLACEHOLDER: "Surname",
  SURNAME_REQUIRED: "Surname is required.",
  END_DATE_NAME: "end-date",
  START_TIME_NAME: "start-time",
  START_DATE_NAME: "start-date",
  INDEX: 0,
  LIMIT: 6,
  VEHICLE_LIMIT: 10,
  SORT_ORDER: -1,
  USER_ROLE: "role",
  PASSWORD_REQUIRED: "Password is required.",
  PASSWORD_MINLENGTH: "Password must be of minimum 6 characters.",
  EMAIL: "Email",
  PASSWORD: "Password",
  LOGIN_HEADING:
    "If you are unsure if we are a good fit to your company,please click here for more details",
  CAPTCHA_INPUT: "Captcha",
  CAPTCHA_PLACEHOLDER: "Captcha",
  CAPTCHA_REQUIRED: "Captcha is required.",
  REGISTER_HEADING_LABEL: "LOGIN OR REGISTER TO FINALISE YOUR REQUEST",
  GOOGLE_SIGNUP_BUTTON_LABEL: "Sign Up With Google",
  FACEBOOK_SIGNUP_BUTTON_LABEL: "Sign Up With Facebook",
  PASSWORD_LABEL: "Password",
  RE_ENTER_PASSWORD: "Re-enter password",
  RE_ENTER_PASSWORD_INPUT: "reenter_password",
  INVALID_NUMBER: "Only numbers are allowed",
  PASSWORD_DO_NOT_MATCH: "Passwords mismatch.",
  BUTTON_LABEL_REGISTER: "REGISTER",
  SUBSCRIBE_INPUT: "subscribe",
  SUBSCRIBE: "Subscribe for news and promotions",
  EMAIL_LABEL: "Email",
  NAME_LABEL: "Name",
  COUNTRY: "Country",
  CITY: "City",
  FREE_DAYS_LABEL: "Free Days",
  PAID_DAYS_LABEL: "Paid days",
  TOTAL: "Total:",
  NAME_REQUIRED: "Name is required.",
  PASSENGER_VANS_LABEL: "Passenger Vans",
  ROLE_REQUIRED: "User role is required.",
  RECREATIONAL_VEHICLE_LABEL: "Recreational Vehicles",
  TRUCK_VANS_LABEL: "Trucks and Vans",
  COUNTRY_REQUIRED: "Country is required.",
  CITY_REQUIRED: "City is required.",
  DESCRIPTION_REQUIRED: "Description is required.",
  EVENT_DESCRIPTION_REQUIRED: "Event description is required.",
  START_TIME_REQUIRED: "Time is required.",
  VALUE_CANNOT_BE_ONLY_SPACES: "Value cannot be only spaces.",
  NAME_PLACEHOLDER: "Name",
  EMAIL_PLACEHOLDER: "Email",
  PASSWORD_PLACEHOLDER: "Password",
  VIEW_BTN_LABEL: "VIEW",
  SEARCH_LABEL: "Search preferences:",
  MODIFY_SEARCH_LABEL: "Modify Search",
  ADVANCED_FILTERS: "Advanced Filters:",
  COMMENT_AGENCY_NAME: "Comment",
  CANCELLED_TRIP_LABEL: "Cancelled Trips:",
  COMMENT_RELO_NAME: "Enter Comment",
  COMMENT_PLACEHOLDER: `Type your comments here...`,
  TRIP_LIMIT: 5,
  USER_ROLE_PLACEHOLDER: "Select Role",
  KEEP_ME_SIGNED_IN_CHECKBOX_NAME: "Remember me",
  KEEP_ME_SIGNED_IN: "Keep me signed in",
  FORGOT_PASSWORD: "Forgot Password?",
  FORGOT_USERNAME: "ForgotUsername?",
  BUTTON_LABEL_LOGIN: "Log In",
  ADD_USER: "Add User",
  REMEMBER_ME: "Remember me",
  IS_FUEL_INCLUDED: "Is Fuel included?",
  IS_EXPENSES_INCLUDED: "Is Expenses included?",
  IS_FERRY_COST_INCLUDED: "Is Ferry cost included?",
  DRIVER_MINIMUM_AGE: "Driver minimum age:",
  CARDS_ACCEPTED: "Cards accepted:",
  EMAIL_INVALID: "Email is invalid.",
  END_DATE_MUST_BE_GREATER: "End date must be greater than start date.",
  SEND_EMAIL: "Submit",
  LOG_IN: "Log In?",
  FORGOT_LOGIN: "Log in",
  CHECK_YOUR_MAIL: "Check your mail!",
  EMAIL_RESPONSE_MESSAGE:
    "Reset password link has been sent to your email address.",
  SHARE_EMAIL_MESSAGE:
    "Enter your email address, We will send you a link to reset your password.",
  LOGOUT: "Logout",
  DASHBOARD: "Dashboard",
  HOME: "Home",
  OKAY: "Okay",
  PICKUPLOCATION: "Select Pick-up Location",
  PICKUPDATE: "Select Pick up Date",
  BOTH_PICKUP: "Select Pick-up Location and Pick-up Date",
  PICKUPDATE_CONTENT: "Please select a pickup date before proceeding.",
  PICKUPDLOCATION_CONTENT: "Please select a pickup location before proceeding.",
  PICKUP_CONTENT:
    "Please select a pickup location and a pickup date before proceeding.",
  CONFIRM: "Confirm",
  CANCEL: "Cancel",
  NAME: "Name",
  PHONE_CODE_MISMATCH_WITH_COUNTRY: "Phone Code and Country mismatch.",
  MAKE_REQUEST_BTN_LABEL: "MAKE A REQUEST",
  ROLE: "Role",
  ACTION: "Action",
  NEWS_FEEDS: "News Feeds",
  DISPLAYING: "Displaying",
  OUT_OF: "out of",
  ALL: "All",
  DRIVERS: "Driver",
  REQUEST: "YOUR REQUEST",
  MEDIA: "Media",
  SECURITY: "Security",
  NO_RECORDS_FOUND: "No matched records found",
  NO_OF_ROWS: "No. of Rows",
  ACCEPT_USER_CONTENT: "Are you sure you want to approve this user?",
  ACCEPT_USER: "Approve User",
  REJECT_USER_CONTENT: "Are you sure you want to reject this user?",
  REJECT_USER: "Reject User",
  USERS: "Users",
  REQUESTS: "Requests",
  ADDITIONAL_INFO_LABEL: "Additional Information:",
  DASHBOARD_PAGE_TITLE: "ECR Dashboard",
  FEEDS_PAGE_TITLE: "ECR Feeds",
  USERS_PAGE_TITLE: "ECR Users",
  REQUESTS_PAGE_TITLE: "ECR Users Requests",
  TESTS_PAGE_TITLE: "ECR Tests",
  TRIP_DETAILS_LABEL: "Trip Details:",
  DRIVER_TRIP_LABEL: "Trips",
  UPCOMING_TRIP_LABEL: "Upcoming Trips:",
  PAST_TRIP_LABEL: "Past Trips:",
  EVENTS_PAGE_TITLE: "ECR Events",
  FORGOT_PAGE_TITLE: "ECR Forgot Password",
  LOGIN_PAGE_TITLE: "ECR Login",
  REGISTER_PAGE_TITLE: "ECR Register",
  USER_DETAIL_PAGE_TITLE: "ECR User Details",
  COST_SUMMARY_LABEL: "Cost Summary",
  TRAVEL_DATE: "Select your travel dates:",
  USERS_TITLE: "Users -",
  EVENT_TITLE: "Events ",
  EMERGENCY_CONTACTS: "Emergency Contacts -",
  STATUS: "Status",
  ACTIVE: "Active",
  REGISTERED: "Registered",
  REQUESTED: "Requested",
  INVITED: "Invited",
  IMPORT_CSV: "Import CSV",
  FREE_DAYS_AVAILABLE_LABEL: "Free days available:",
  EXTRA_PAID_DAYS_AVAILABLE_LABEL: "Extra paid days available:",
  FILE_TYPE_REJECTED:
    "Selected file format is not supported! Please choose .csv file format",
  DONE: "done",
  REJECTED_FILE_TYPE: "rejected_file_type",
  SENDEMAIL: "Send Email",
  PICKUPFROM_LABEL: "Pick-up from:",
  PICKUPTIME_LABEL: "Pick-up time:",
  TRAVEL_DIST_LABEL: "Estimated travel distance",
  KMALLOW_LABEL: "Kilometres allowance",
  DROP_OFFTIME_LABEL: "Drop-off time:",
  USERS_LIST: "Users List",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  DATE: "Date",
  START_TIME: "Time",
  EVENT_NAME: "Event Name",
  START_DATE_REQUIRED: "Start date is required.",
  END_DATE_REQUIRED: "End date is required.",
  ADMIN_NAME_REQUIRED: "Admin name is required.",
  DESCRIPTION_PLACEHOLDER: "Description",
  CHANGE_PASSWORD: "Change your password",
  ATTEMPT: "Attempt(s)",
  PERCENTAGE: "Percentage",
  ADMIN_NAME_PLACEHOLDER: "Enter Admin name",
  ADMIN_EMAIL_PLACEHOLDER: "Enter Admin email",
  EVENT_LIST: "Events List",
  EMPTY_TEST_HEADING: "It seems you haven’t added any test.",
  EMPTY_CREATE_TEST_HEADING: "It seems you haven’t created any test.",
  EMPTY_TEST_DESCRIPTION: `You can add test by clicking on the button below.`,
  ADD_TEST: "Add Test",
  TEST_INSTRUCTION: "instruction",
  TEST_INSTRUCTION_PLACEHOLDER: "Type instruction here",
  TEST_INSTRUCTION_LABEL: "Instructions",
  TEST_TITLE: "Test",
  TEST_INSTRUCTION_REQUIRED: "Test instruction is required.",
  USER_TYPE: "user_type",
  QUESTION_TYPE: "question_type",
  USER_TYPE_LABEL: "User Type",
  QUESTION_TYPE_LABEL: "Question Type",
  QUESTION_TITLE: "question_title",
  QUESTION_TITLE_LABEL: "Question Title",
  TYPE_HERE: "Type here...",
  RIGHT_ANSWER_OPTIONS: "right answer option",
  ANSWER_OPTIONS: "answer option",
  TEST_TYPE: "Test Type",
  NO_OF_QUESTION: "No. of Question(s)",
  ANSWER_TYPE: "answer_type",
  QUESTION_TIME: "question_time",
  QUESTION_TIME_LABEL: "Question Time ",
  MINUTE_INPUT: "question_minute",
  SECONDS_INPUT: "question_seconds",
  FILE: "file",
  ANSWER_TYPE_LABEL: "Answer Type",
  USER_TYPE_REQUIRED: "User type is required",
  QUESTION_TYPE_REQUIRED: "Question type is required.",
  ANSWER_TYPE_REQUIRED: "Answer type is required.",
  QUESTION_TITLE_REQUIRED: "Question title is required.",
  ANSWER_OPTION_LIST: "answer",
  ANSWER_LIST: "answer_list",
  RIGHT_OPTION_LIST: "right_option_list",
  EMERGENCY_ACCESS: "Emergency Access",
  DRIVER_LICENCE_TYPE_REQUIRED: "Please select driver Licence type",
  AMBASSADORS: "Ambassadors",
  ACCESS: "Access",
  LOG_OUT: "Log Out",
  ATTENDEES: "Attendees",
  SUCCESS: "success",
  ERROR: "error",
  SEARCH: "Search",
  USER_TYPE_COLON: "User Type: ",
  LOCATION: "Location",
  PEOPLE_ARE_ATTENDING: "Attendee(s)",
  SEE_ALL: "See all",
  ADD_EVENT: "Add Event",
  ADD_QUESTION: "Add Question",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE:
    "Are you sure you want to delete this event?",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_QUESTION:
    "Are you sure you want to delete this question?",
  DELETE: "Delete Event",
  DELETE_QUESTION: "Delete Question",
  EMPTY_EVENT_HEADING: `It seems you haven't added any event yet.`,
  EMPTY_EVENT_DESCRIPTION:
    "You can add events by clicking on the button below.",
  EMPTY_QUESTIONS_HEADING: `It seems you haven't added any question yet.`,
  EMPTY_QUESTION_DESCRIPTION: `You can add questions by clicking on the button below.`,
  OVERALL_SCORE: "Your Overall Score is",
  ADD_EMERGENCY_USERS: "Add Emergency Users",
  EMPTY_EMERGENCY_HEADING: `It seems you haven't given emergency access to anyone yet.`,
  EMPTY_EMERGENCY_DESCRIPTION:
    "You can add emergency contacts by clicking on the button below.",
  EMPTY_AMBASSADOR_HEADING: `It seems you haven't given ambassador access to anyone yet.`,
  EMPTY_AMBASSADOR_DESCRIPTION:
    "First you have to add Drivers in Users section, then you'll be able to add Ambassadors.",
  SAVE: "Save",
  NA: "NA",
  ADDRESS: "Address",
  NATIONALITY: "Nationality",
  DOB: "dob",
  DOB_REQUIRED: "DOB is required.",
  PHONE_NO: "Phone No",
  BLOOD_GROUP: "Blood Group",
  SUBJECT_INPUT: "Subject",
  SUBJECT_PLACEHOLDER: "Enter Subject...",
  BODY_INPUT: "Body",
  BODY_PLACEHOLDER: "Type Here...",
  CANCEL_TRIP_NOTIFICATION: "Are you sure you want to cancel this trip?",
  CANCEL_TRIP_CONTENT: "Cancel Trip",
  RELATIONSHIP: "Relationship",
  CONTACT_NUMBER: "Contact Number",
  TEAM_NAME: "Team Name",
  ASN_CATEGORY: "ASN/Category",
  FIA_CATEGORIZATION: "FIA Categorization",
  LICENSE_NUMBER: "License Number",
  VEHICLE_REGISTRATION_NUMBER: "Vehicle Registration Number",
  INSURANCE_POLICY_NUMBER: "Insurance Policy Number",
  MEDICAL_DETAILS: "Medical Details",
  EMERGENCY_DETAILS: "Emergency Details",
  VEHICLE_DETAILS: "Vehicle Details",
  STATISTICS: "Statistics",
  FILE_NOT_UPLOADED_YET: "File not uploaded yet.",
  UPLOAD: "Upload",
  OR: "Or",
  LICENSE_HOLDING_REQUIRED: "Select a value for license holding",
  IT_SEEMS: "It seems",
  DIDNT_RESPONDED_TO_INVITATION: `didn't respond to the invitation you sent. Let's send them a reminder.`,
  YOUR_INVITATION_SENT_TO: "Your invitation has been sent to",
  FOR: "for",
  PROFILE: "profile",
  EMPTY_USER_HEADING: `It seems you haven't added any user here.`,
  EMPTY_USER_DESCRIPTION: `You can import or add users by clicking on any of the below buttons.`,
  ADD: "Add",
  DETAILS: "Details",
  EDIT: "Edit",
  COMPLETE_PROFILE_TITLE: "Complete Your Details",
  COMPLETE_PROFILE_CONTENT:
    "We require your complete details before proceeding ahead, kindly complete your details first.",
  ADD_ADMIN: "Add Admin",
  REMOVE_ADMIN: "Remove Admin",
  ADMINS: "Admins",
  DELETE_ADMIN_DESCRIPTION: "Are you sure you want to delete this Admin?",
  DELETE_ADMIN_HEADING: "Delete Admin",
  PLUS: "+",
  MINUS: "-",
  ADVANCE_SEARCH_RESET_BUTTON_LABEL: "Reset",
  RESET_LABEL: "RESET",
  ADVANCE_SEARCH_BUTTON_LABEL: "Submit",
  MANUAL_LABEL: "Manual",
  MANUAL_INPUT: "Manual",
  AUTOMATIC_LABEL: "Automatic",
  AUTOMATIC_INPUT: "Automatic",
  TRUCKVANS_LABEL: "Truck & Vans",
  TRUCKVANS_INPUT: "TruckAndVans",
  INVALID_NAME: "Name cannot have digits or special characters.",
  RECREATIONALVANS_INPUT: "RecreationalVans",
  RECREATIONALVANS_LABEL: "Recreational Vans",
  PASSENGERVANS_LABEL: "Passenger Vans",
  PASSENGERVANS_INPUT: "PassengerVans",
  CARS_LABEL: "Cars",
  CARS_INPUT: "Cars",
  ELECTRIC_LABEL: "Electric",
  ELECTRIC_INPUT: "Electric",
  DIESEL_INPUT: "Diesel",
  DIESEL_LABEL: "Diesel",
  PETROL_INPUT: "Petrol",
  PETROL_LABEL: "Petrol",
  ADULT_SEAT_LABEL: "Adult Seats",
  CHILD_SEAT_LABEL: "Child Seats",
  SEARCH_BUTTON_LABEL: "Search Now",
  PICKUP_DATE_PLACEHOLDER: "Pick-up Date",
  PICKUP_LOCATION_PLACEHOLDER: "Pick-up Location",
  PICKUP_DATE_INPUT: "PickupDate",
  PICKUP_LOCATION_INPUT: "PickupLocation",
  MANAGE_ROLES: "Manage User Types",
  LOCATION_REQUIRED: "Pick up location is required.",
  DATE_REQUIRED: "Date is required.",
  FUEL_OPTIONS_LABEL: "Fuel Options",
  SEATS_LABEL: `Number of Seats`,
  TRANSMISSION_LABEL: "Transmission Options",
  VEHICLE_TYPE_LABEL: "Vehicle Type",
  PHONE_NUMBER_CHARACTER_LENGTH: "Phone number must be 7-15 characters long",
  INVALID_CAPTCHA: "Invalid captcha code.Please try again.",
  PASSWORD_LENGTH_VALIDATION: "Password must contain at least 6 characters.",
  COMPANY_NAME: "companyName",
  COMPANY_NAME_PLACEHOLDER: "Company Name",
  RIBE_REQUIRED: "Please subscribe for news and promotion.",
  PHONE_NUMBER_KEY: "phoneNumber",
  DRIVER_OR_AGENCY_KEY: "driverOrAgency",
  PHONE_NUMBER_REQUIRED: "Phone no. is required.",
  PHONE_CODE_KEY: "phoneKey",
  MESSAGE_FIELD_KEY: "message",
  MESSAGE_FIELD_REQUIRED: "Message field is empty",
  BRANCH_REQUIRED: "Branch name is required.",
  ADDRESS_REQUIRED: "Address is required.",
  PHONE_NUMBER_PLACEHOLDER: "Phone code",
  SUBURB_REQUIRED: "Suburb is required.",
  CLOSE_BY_REQUIRED: "Close by is required.",
  POSTCODE_REQUIRED: "Postcode is required.",
  PHONE_CODE_KEY_REQUIRED: "Phone code is required.",
  CODE_REQUIRED: "Code is required.",
  DOB_PLACEHOLDER: "D.O.B.",
  BRANCH_MANAGER_REQUIRED: "Branch manager is required.",
  PICK_DROP_TO_REQUIRED: "Pickup/Dropoff to is required.",
  OPEN_FROM_REQUIRED: "Open from is required.",
  PICK_DROP_REQUIRED: "Pickup/Dropoff from is required.",
  VALUE_CANNOT_BE_EMPTY_SPACES: "Phone number cannot include spaces.",
  NAME_VALIDATION: "Name cannot have numbers and special characters.",
  CITY_NAME_VALIDATION: "City cannot have numbers and special characters.",
  SURNAME_VALIDATION: "Surname cannot have numbers and special characters.",
  PHONE_NO_VALIDATION: "Phone no. is not valid.",
  INVALID_NUMBER_FOR_COUNTRY: "Phone number is not valid.",
  NO_INTERNET: "You appear to be offline. Please check your connection.",
  I_M_NEW: "I'M NEW",
  LOGIN: "LOGIN",
  PUBLISHED_LISTING: "PUBLISHED LISTING",
  BOOKED: "BOOKED",
  PENDING_REQUESTS: "PENDING REQUESTS",
  CANCELLATIONS: "CANCELLATIONS",
  LISTING_IMPRESSIONS: "LISTING IMPRESSIONS",
  VEHICLE: "Vehicle",
  QUANTITY: "Quantity",
  PICK_UP_LOCATION: "Pick-up Location",
  DROP_OFF_LOCATION: "Drop-off Location",
  LISTING_DATE: "Listing Date",
  LAST_UPDATED: "Last Updated",
  OPERATOR: "Operator",
  REFERENCE: "Reference",
  ID: "Id",
  STAR_RATING: "Star Rating",
  COMMENTS: "Comments",
  PICK_UP_DATE: "Pick-up Date",
  DROP_OFF_DATE: "Drop-off Date",
  PICK_UP_TIME: "pickuptime",
  DROP_OFF_TIME: "dropofftime",
  PICK_UP_TIME_PLACEHOLDER: "Pick-up Time",
  DROP_OFF_TIME_PLACEHOLDER: "Drop-off Time",
  PICK_UP_DATE_PLACEHOLDER: "Pick-up Date",
  DROP_OFF_DATE_PLACEHOLDER: "Drop-off Date",
  BUTTON_LABEL_BACK: "Back",
  BUTTON_LABEL_NEXT: "Next",
  DRIVER_NAME: "Driver Name",
  LOGOUT_CONTENT: "Are you sure you want to logout?",
  DATA_LOST_CONTENT:
    "You will loose all your data. Are you sure you want to logout?",
  REGO: "Rego",
  ADD_NEW_BRANCH: "Add a new branch:",
  BRANCH_NAME: "branchName",
  BRANCH_NAME_PLACEHOLDER: "Branch name",
  AGENCY_HEADER: "Welcome back, Francis from Bargain Rental Cars",
  DRIVER_RATING_HEADER: "Rate your drivers",
  PAST_RATINGS: "Past Ratings",
  PICK_UP_DATE_NAME: "pickupdate",
  DROP_OFF_DATE_NAME: "dropoffdate",
  INVALID_TIME: "Invalid time.please try again.",
  ADD_NEW_LISTING: "Add a new listing",
  HERE_YOUR_DASHBOARD: "Here is your dashboard:",
  VIEW: "View",
  GO: "Go ",
  ADD_NEW: "Add new",
  VEHICLES: "vehicles",
  QUANTITY_NAME: "quantity",
  REFERENCE_NAME: "reference",
  PICK_UP_LOCATION_NAME: "PickUpLocation",
  DROP_OFF_LOCATION_NAME: "DropOffLocation",
  INSURANCE_NAME: "insurance",
  FERRYCOST_NAME: "ferryCost",
  FUEL_NAME: "fuel",
  EXPENSES_NAME: "expenses",
  DETAILS_NAME: "details",
  FREE_DAYS_AVAILABLE_NAME: "freeDaysAvailable",
  KILOMETRES_ALLOWED_NAME: "kilometresAllowed",
  AVAILABLE_DAYS: "Available days",
  SELECTED_PAID_DAYS: "Selected paid days",
  SELECTED_FREE_DAYS: "Selected free days",
  EXTRA_PAID_DAYS_NAME: "extraPaidDays",
  RATE_PER_DAY_NAME: "ratePerDay",
  COMMENTS_NAME: "comments",
  YOUR_SAVED_LISTS__NAME: "yourSavedLists",
  INSURANCE_SELECT: "insuranceSelect",
  FERRYCOST_SELECT: "ferryCostSelect",
  FUEL_NAME_SELECT: "fuelSelect",
  BOOK: "book",
  NO_SHOW: "noShow",
  EXPIRE: "expire",
  VEHICLE_TYPE_NAME: "vehicleType",
  VEHICLE_CATEGORY_NAME: "vehicleCategory",
  VEHICLE_NAME_NAME: "vehicleName",
  VEHICLE_CODE_NAME: "vehicleCode",
  DRIVER_LICENCE_TYPE_NAME: "vehicleLicenceType",
  VEHICLE_DESCRIPTION_NAME: "vehicleDescription",
  VEHICLE_TRANSMISSION_NAME: "vehicleTransmission",
  FUEL_TYPE_NAME: "fuelType",
  VEHICLE_RANGE_NAME: "vehicleRange",
  VEHICLE_RANGE_FROM: "vehicleRangeFrom",
  VEHICLE_RANGE_To: "vehicleRangeTo",
  ADULT_SEATS_NAME: "adultsSeats",
  CHILD_SEATS_NAME: "childSeats",
  LARGE_LUGGAGE_NAME: "largeLuggage",
  SMALL_LUGGAGE_NAME: "smallLuggage",
  TEMPLATE_NAME: "templateName",
  TEMPLATE_DESCRIPTION: "templateDescription",
  AIR_CONDITION_TYPE: "airConditionType",
  NUMBER_OF_DOORS: "noOfDoors",
  DRIVER_AGE: "driverMinAge",
  ESTIMATED_DISTANCE: "estimatedDistance",
  EMAIL_IS_NOT_VALID: "Email is not valid.",
  FAVORITE: "Favourite",
  BOOKING_ID: "Booking Id",
  SHORT_DESCRIPTION: "shortDescription",
  REQUESTED_INFORMATION_DRIVER: "requestedInformationDriver",
  CONFRIMED_INFORMATION_DRIVER: "confirmedInformationDriver",
  ONLY_ALLOW_CREDIT_CARD: "onlyCreditCardAllowed",
  RESTRICTED_LICENSE_ALLOWED: "driverWithRestrictedLicense",
  OVERSEAS_DRIVER_ALLOWED: "overseasDriversAllowed",
  LICENCE_HOLD_REQUIRED: "driverHoldingLicense",
  FERRY_COST_NAME: "ferryCostName",
  FERRY_COST_DESCRIPTION: "ferryCostDescription",
  BRANCH_MANAGER_EMAIL: "branchMemberEmail",
  BRANCH_MANAGER_DOB: "branchMemberDob",
  BRANCH_MANAGER_PASSWORD: "branchMemberPassword",
  CONFIRM_PASSWORD: "confirmPassword",
  PHONE_NAME: "phone",
  ADDRESS_INPUT_NAME: "address",
  SUBURB_INPUT_NAME: "suburb",
  SUBURB_PLACEHOLDER: "Suburb",
  POSTCODE_INPUT: "postcode",
  POSTCODE_INPUT_PLACEHOLDER: "Postcode",
  CODE_PLACEHOLDER: "Code",
  CODE_INPUT: "code",
  PICK_UP_DROP_OFF_TO_FIRST: "pick-updrop-offto1",
  PICK_UP_DROP_OFF_FROM: "Pick-up/Drop-off from ",
  OPEN_FROM: "openfrom",
  OPEN_FROM_PLACEHOLDER: "Open from ",
  PICK_UP_DROP_OFF_TO_SECOND: "pick-updrop-offto2",
  PICK_UP_DROP_OFF_TO: "Pick-up/Drop-off to",
  CLOSE_BY: "closeby",
  CLOSE_BY_PLACEHOLDER: "Close by",
  BRANCH_MANAGER: "branchManager",
  FUEL_INPUT: "fuelName",
  BRANCH_MANAGER_SELECT_PLACEHOLDER: "Branch manager (select)",
  FUEL_DESCRIPTION: "fueldescription",
  INSURANCE_MODAL_NAME: "insuranceName",
  INSURANCE_NAME_PLACEHOLDER: "Insurance Name",
  PICK_UP_DROP_OFF_FROM_GREATER_THAN_OPENING_TIME:
    "Pickup/dropoff from time must be greater than opening time.",
  PICK_UP_DROP_OFF_FROM_GREATER_THAN_PICK_UP_DROP_OFF_TO:
    "Pickup/dropoff from time must be greater than Pickup/dropoff to.",
  PICK_UP_DROP_OFF_FROM_20MINT_GREATER_THAN_PICK_UP_DROP_OFF_TO:
    "Pickup/Dropoff from must 20 minutes less than Pickup/Dropoff to.",
  OPENING_TIME_LESS_THAN_PICK_DROP_OFF:
    "Opening time must be less than pickup/dropoff from time.",
  PICK_DROP_TO_LESS_THAN_CLOSING_TIME:
    "Pickup/Dropoff to time must be less than closing time.",
  PICK_DROP_1HOUR_GREATER_THAN_OPRNING:
    "Pickup/Dropoff to must be min 1 hour greater than opening time.",
  PICK_DROP_TO_GREATER_THAN_PICK_DROP_FROM:
    "Pickup/Dropoff to must greater than Pickup/Dropoff from.",
  PICK_UP_DROP_OFF_TO_20MINT_GREATER_THAN_PICK_UP_DROP_OFF_FROM:
    "Pickup/Dropoff to must 20 minutes greater than Pickup/Dropoff from.",
  CLOSING_TIME_GREATER_THAN_PICK_DROP_OFF_TO:
    "Closing time must be greater than pickup/dropoff to time.",
  CLOSING_TIME_LESS_THAN_PICK_DROP_OFF_FROM:
    "Closing time must be less than pickup/dropoff from time.",
  CLOSING_TIME_MUST_GREATER_THAN_OPENING_TIME:
    "Closing time must be greater than opening time.",
  CLOSING_TIME_1HOUR_GREATER_THAN_OPENING_TIME:
    "Closing time must be min 1 hour greater than opening time.",
  EXCESS_REQUIRED: "Excess is required.",
  BOND_REQUIRED: "Bond is required.",
  DAILY_FEE_REQUIRED: "Daily fee is required.",
  EXCESS_NAME: "excess",
  EXCESS_PLACEHOLDER: "Excess $",
  BOND_NAME: "bond",
  BOND_PLACEHOLDER: "Bond",
  DAILY_FEE_NAME: "dailyFee",
  DRIVER_DETAILS: "Driver Details",
  DAILY_FEE_PLACEHOLDER: "Daily Fee for Excess Reduction $",
  RANGE_REQUIRED: "Range is required.",
  VEHICLE_TYPE_REQUIRED: "Vehicle type is required",
  VEHICLE_CATEGORY_REQUIRED: "Vehicle category is required.",
  VEHICLE_LICENSE_TYPE_REQUIRED: "Vehicle license type is required.",
  VEHICLE_NAME_REQUIRED: "Vehicle name required.",
  VEHICLE_CODE_REQUIRED: "Vehicle code is required.",
  DOORS_REQUIRED: "Number of doors is required.",
  VEHICLE_DESCRIPTION_REQUIRED: "Vehicle description is required.",
  FUEL_TYPE_REQUIRED: "Please select the Fuel type.",
  VEHICLE_TRANSMISSION_REQUIRED: "Vehicle transmission is required.",
  ADULTS_SEAT_REQUIRED: "Number of adult seats is required.",
  CHILDS_SEAT_REQUIRED: "Number of  child seats is required.",
  LARGE_LUGGAGE_REQUIRED: "Number of large luggage is required.",
  SMALL_LUGGAGE_REQUIRED: "Number of small luggage is required.",
  AIR_CONDITION_REQUIRED: "Air condition type is required.",
  UPLOAD_AT_LEAST_REQUIRED: "Please upload at least one image.",
  CATEGORY_NAME_REQUIRED: "Category name is required.",
  CATEGORY_DESCRIPTION_REQUIRED: "Category description is required.",
  START_RANGE_REQUIRED: "Start range is required.",
  VALID_RANGE_REQUIRED: "Enter the valid range.",
  MAX_YEAR_VALDITION: "Max year must be current year.",
  EXCEEDING_MAX_RANGE: "Exceeding max range year",
  END_RANGE_REQUIRED: "End range is required",
  MAX_VALUE_25: "Max value must be 25.",
  MAX_VALUE_5: "Max value must be 5.",
  MIN_VALUE_2: "Min value must be 2.",
  CATEGORY_NAME_INPUT: "categoryName",
  CATEGORY_PLACEHOLDER: "Please enter a category name",
  CATEGORY_DESCRIPTION_INPUT: "categoryDescription",
  CATEGORY_DESCRIPTION_PLACEHOLDER: "Please enter a category description",
  VEHICLE_TYPE_PLACEHOLDER: "Please select a vehicle type",
  VEHICLE_CATEGORY_PLACEHOLDER: "Please select a vehicle category",
  DRIVER_LICENCE_TYPE_PLACEHOLDER: "Please select a driver licence type",
  VEHICLE_NAME_PLACEHOLDER: "Enter your vehicle name",
  //ENTER_VEHICLE_CODE_PLACEHOLDER: "You can enter a code for the vehicle",
  VEHICLE_DESCRIPTION_PLACEHOLDER: "Vehicle Description",
  VEHICLE_TRANSMISSION_PLACEHOLDER: "Please select vehicle transmission",
  FUEL_TYPE_PLACEHOLDER: "Please select Fuel Type",
  VEHICLE_YEAR_RANGE_TO: "Vehicle Year Range: to",
  AIR_CONDITION_PLACEHOLDER: "Please select air condition type",
  ADULTS_SEATS_PLACEHOLDER: "Enter number of adult seats",
  CHILD_SEATS_PLACEHOLDER: "Enter number of children seats",
  LARGE_LUGGAGE_PLACEHOLDER: "Enter number of large luggage",
  SMALL_LUGGAGE_PLACEHOLDER: "Enter number of small luggage",
  DOORS_PLACEHOLDER: "Enter number of doors",
  BRANCH_NAME_INPUT: "branchName",
  DRIVER_AGE_REQUIRED: "Please enter the driver age.",
  ESTIMATED_DISTANCE_REQUIRED: "Please enter the estimated distance.",
  ESTIMATED_DISTANCE_GREATER_THAN_0:
    "Estimated distance must be greater than 0.",
  DRIVER_AGE_GREATER_THAN_15: "Driver age must be greater than 20.",
  DRIVER_AGE_LESS_THAN_100: "Driver age must be less than 100",
  VEHICLE_REQUIRED: "Please select the vehicle",
  QUANTITY_REQUIRED: "Please enter the quantity.",
  MIN_VALUE_1: "Min value must be 1.",
  PICK_UP_LOCATION_REQUIRED: "Please enter pick up location.",
  PICK_UP_DATE_REQUIRED: "Please enter pick up date.",
  PICK_UP_TIME_REQUIRED: "Please enter pick up time.",
  DROP_OFF_REQUIRED: "Please enter drop off location.",
  DROP_OFF_DATE_REQUIRED: "Please enter drop off date.",
  DROP_OFF_TIME_REQUIRED: "Please enter drop off time.",
  INSURANCE_REQUIRED: "Please select the insurance.",
  INSURANCE_CHECKBOX_REQUIRED: "Please select the insurance checkbox.",
  FERRY_REQUIRED: "Please select the ferry.",
  VEHICLE_IMAGE_NAME: "vehicleImage",
  VEHICLE_IMAGE_PLACEHOLDER: "Select vehicle image",
  PRICE_REQUIRED: "Price is required",
  FREQUENCY_REQUIRED: "Frequency is required.",
  NEW_ITEM_NAME: "new_item_description",
  LIST_NAME_REQUIRED: "Please enter a list name",
  FERRY_CHECKBOX_REQUIRED: "Please select the ferry checkbox.",
  FUEL_REQUIRED: "Please select the fuel.",
  FUEL_CHECKBOX_REQUIRED: "Please select the fuel checkbox.",
  DETAILS_REQUIRED: "Please enter the details.",
  EXPENSES_CHECKBOX_REQUIRED: "Please select the expenses checkbox.",
  FREE_DAYS_REQUIRED: "Please enter the free days.",
  FREE_DAYS_LESS_THAN_46: "Free days must be less than 46.",
  RATE_PER_DAY_REQUIRED: "Please enter the rate per days.",
  EXTRA_PAID_DAYS_REQUIRED: "Please enter the extra paid days.",
  TEMPLATE_REQUIRED: "Template name is required.",
  TEMPLATE_DESCRIPTION_REQUIRED: "Template description is required.",
  WEBSITE_INPUT_NAME: "website",
  REQUESTED_INFO_DRIVER_INPUT_NAME: "requestedInformationToDriver",
  CONFIRM_INFO_DRIVER_INPUT_NAME: "confirmationInformationToDriver",
  PAYMENT_COND_INPUT_NAME: "paymentConditions",
  LIST_CONDITION_REQUIRED: "Please list the conditions.",
  COMPANY_NAME_REQUIRED: "Please enter the company name.",
  ENTER_PHONE_NUMBER_REQUIRED: "Please enter the phone number.",
  ENTER_EMAIL_REQUIRED: "Please enter the email.",
  ENTER_ADDRESS_REQUIRED: "Please enter the address.",
  ENETR_CITY_REQUIRED: "Please enter the city.",
  ENTER_COUNTRY_REQUIRED: "Please enter the country.",
  ENTER_PHONE_CODE_REQUIRED: "Please enter the phone code.",
  MEMBER_CITY_INPUT: "memberCity",
  MEMBER_COUNTRY_INPUT: "memberCountry",
  MEMBER_PHONE_KEY_INPUT: "memberPhoneKey",
  MEMBER_PHONE_INPUT: "memberPhoneNumber",
  MEMBER_NAME_INPUT: "memberName",
  PICK_UP_DROP_OFF1: "pickupdropoff1",
  PICK_UP_DROP_OFF2: "pickupdropoff2",
  ENTER_BRANCH_NAME_REQUIRED: "Please enter the branch name.",
  ENTER_SUBURB_REQUIRED: "Please enter the suburb.",
  ENTER_POSTCODE_REQUIRED: "Please enter the postcode.",
  ENTER_CODE_REQUIRED: "Please enter the code.",
  WEBSITE_PLACEHOLDER: "Website",
  ABOUT_COMPANY_SHORT_DESC_PLACEHOLDER: "About Company - Short Description",
  OTHER_THAN_CREDIT_CARD_DESCRIPTION_PLACEHOLDER:
    "If yes, please list conditions here",
  MINIMUM_AGE_PLACEHOLDER: "Minimum age",
  YOUR_SAVED_VEHICLE: "Your saved Vehicles",
  ESTIMATED_DISTANCE_PLACEHOLDER: "Estimated Trip Distance in kms",
  FREE_DAYS_PLACEHOLDER: "Free Days Available",
  KILLOWMETRE_PLACEHOLDER: "Kilometres allowed",
  EXTRA_PAID_DAYS_PLACEHOLDER: "Extra Paid Days",
  RATE_PER_DAY_PLACEHOLDER: "Rate per day $",
  YOUR_SAVED_CARD_PLACEHOLDER: "Your saved lists",
  ENTER_LIST_NAME_PLACEHOLDER: "Enter New List Name:",
  YOUR_SAVED_TEMPLATE_PLCAHOLDER: "Your saved Templates",
  TEMPLATE_NAME_PLACEHOLDER: "Name your template",
  PICK_UP_DROP_OFF_GREATER_THAN_OPENING_TIME:
    "Pickup/Dropoff time must be greater than opening time.",
  ENTER_VEHICLE_CODE_PLACEHOLDER: "Enter your vehicle code",
  YEAR_RANGE_FROM_PLACEHOLDER: "Year range from:",
  YEAR_RANGE_TO_PLACEHOLDER: "Year range to:",
  ENTER_VEHICLE_TYPE_REQUIRED: "Please select the vehicle type.",
  ENTER_VEHICLE_NAME_REQUIRED: "Please enter the vehicle name.",
  ENTER_VEHICLE_DESCRIPTION_REQUIRED: "Please enter the vehicle description.",
  ENTER_VEHICLE_CODE_REQUIRED: "Please enter the vehicle code.",
  ENTER_CHILD_SEATS_REQUIRED: "Please enter the child seats.",
  ENTER_SMALL_LUGGAGE_REQUIRED: "Please enter the small luggage.",
  MAX_UPTO_25: "Max upto 25.",
  ENTER_ADULTS_SEATS_REQUIRED: "Please enter the adults seats.",
  ENTER_LARGE_LUGGAGE_REQUIRED: "Please enter the large luggage.",
  ENTER_TRANSMISSION_TYPE: "Please select the transmission type.",
  ENTER_FUEL_TYPE_REQUIRED: "Please select the fuel type.",
  ENTER_VEHICLE_CATEGORY_REQUIRED: "Please select the vehicle category.",
  ENTER_AIR_CON_REQUIRED: "Please select the air condition type.",
  MAX_UPTO_5: "Max upto 5.",
  MIN_MUST_2: "Min must be 2.",
  ENTER_DOORS_REQUIRED: "Please enter the number of doors.",
  ENTER_VEHICLE_RANGE_REQUIRED: "Please enter the vehicle range.",
  VALID_VEHICLE_RANGE_VALIDATION: "Please enter the valid vehicle range.",
  MIN_YEAR_MUST_1980: "Min year must be 1980.",
  MAX_EXCEED_VALIDATION: "Exceeding max range year.",
  NUMBER_OF_DOORS_PLACEHOLDER: "Please enter number of doors.",
  REFERENCE_LENGTH_MUST_BE_LESS_THAN_13:
    "Reference length must be less than 13",
  TERMS_POPUP_CONTENT:
    "Terms & Conditions easycarrelo.co.nz is a  company registered in NewZealand  (Number: 05179829). These terms & conditions, together with our privacy notice and cookie statement, constitute our agreement with you, for the services we provide in arranging for the supply of car hire. For the avoidance of doubt, ‘you’ refers to the main driver, the person paying for the rental and/or the person making the booking. Please note, although ‘you’ may refer to more than one person, we contract with all parties, but we will only be able to speak to the main driver in respect of a confirmed booking. Together, these are referred to as ‘our terms’. These terms shall apply to all contracts for the provision of our services to the exclusion of all other terms & conditions. No conduct by easycarrelo.c.nz shall be deemed to constitute acceptance of any other terms. Acceptance of the services or signature on any agreement shall be deemed conclusive evidence of your acceptance of these terms. We may change the terms from time to time and you are advised to check the website to consider any changes to the terms which apply to you. Your hire of any car is subject to the terms & conditions of car hire imposed by the car hire company and to the corresponding laws of the country and/or state in which the rental takes place. Individual restrictions may also apply to your car hire.You will be provided with a car by us either directly or as agent. The capacity in which we act depends on our relationship with the car hire company.These terms apply to any booking that you make with us on or through this website, so you should make sure that you are aware of their contents. Both our terms and those of the car hire companies we work with contain some exclusions and limitations of liability.Your booking on this website is conditional on you accepting our terms. If you do not agree with any part of them, you must not proceed with your booking. By confirming that you wish to book a car through this website you,, indicate that you have read and understood and accept our terms. If there is any part that you do not fully understand, or if you have a query about the car hire or any other product, please Contact us.Confirming your booking and taking payment In most cases, we will confirm your booking immediately using the email address provided when the booking is made. Sometimes, we need to wait for the car hire company to confirm that a car is available. We will tell you straight away if this happens, and temporarily block the money on your payment card. As soon as they confirm your car, we will let you know, and take the money from your card.Until your car is confirmed, you can ‘void’ the payment at any time. Just hit ‘Manage booking’ at the top of our site, enter the email address provided when making the booking and reservation number, then hit ‘Cancel Booking’. We will unblock the money on your card.Very rarely, a car hire company can’t confirm that a car is available. If this happens, we will tell you, and unblock the money on your card.When you book a car or other product on our site, we will email you to confirm its availability within 48 hours of booking (or, if earlier, at least 24 hours before your pick-up time). We will then send you a booking confirmation.You will not have a contract until we have confirmed your booking and taken the payment. We will send all correspondence to the address provided when making the booking. For the avoidance of doubt, nothing in these terms shall entitle any third party to any benefit or rights pursuant to the Contracts (Rights of Third Parties) Act 1999 .Accuracy of Information.Although we strive to ensure the accuracy of the information on this website, neither we nor our affiliates, suppliers or agents can be held responsible by you for the accuracy of such information. It is solely your responsibility to evaluate the accuracy, completeness and usefulness of all information provided on this website.The easycarrelo.c.nz voucher / eVoucher must be presented to the car hire company when picking up your hire car. We cannot be held responsible for rentals rejected if a voucher / eVoucher is not presented.We cannot accept liability for any charges incurred as a result of documentation signed for and accepted at the car hire counter.We will not be held responsible for anyone driving under the influence of alcohol/drugs, causing wilful damage, driving off-road or driving without due care and attention. You, will accept full responsibility in respect of such claims. This list is not exhaustive.What is included / excluded in the price.Please read the specific terms & conditions relating to your car hire, which you will see during the booking process.Fuel & Deposits at the Car Hire Counter.Most car hire companies require a deposit at the start of the rental to cover the liability excess, any charges incurred during the rental and, in some cases, fuel. In order to make the deposit you will usually be required to have a valid credit card with available funds on it. The card must be in the main driver’s name. Please note, not all car hire companies accept the same card types and you should check the “Important Information” section when making a booking and/or your car hire agreement to confirm which card types will be accepted. If you still have any questions please contact us. Provided the car and extras are returned in the same state as rented and in accordance with the fuel policy, this deposit will be refunded after dropping the car off (please note that it may take up to 30 days for the money to appear on your credit card again).Some car hire companies will require you to return the car with the same amount of fuel it had in the tank at pick-up. Others operate a fuel policy where you, must purchase the first tank of fuel and may drop the car off empty – in which case, there may be no refund for unused fuel.Where the car hire company charges for fuel, the cost may be higher than it would be at a local petrol station.Out-of-Hours Serve.At most airport locations, flights will be met and cars supplied outside normal working hours. However, there may be an additional charge for this service, which will be payable directly to the car hire company. We will advise you whether a charge will apply when you confirm your pick-up times in your booking request. In the event that a flight delay causes the car pick-up to fall outside a car hire company’s normal working hours, the car hire company may agree to provide an out-of-hours service – in which case they will advise you of any fee. We can accept no further responsibility where there is no out-of-hours service available – and it is therefore recommended that you take independent travel insurance. Non-airport car hire counters may also provide an out-of-hours service.Minimum / Maximum Age Limitations.In most locations, the minimum hiring age is 21 years. Additional fees can apply with certain car hire companies and in certain countries for drivers aged under 25 years or over 65 years: where the correct driver age has been submitted with the booking request, we will advise of any likely fees. Minimum age requirements on larger cars may also be higher at some locations. Please check with our Contact Centre if you  have any questions or concerns about this matter.Additional Drivers.Fees may apply for additional drivers, payable at the car hire counter (unless otherwise specified on the easycarrelo.c.nz voucher / eVoucher). Please check with our Contact Centre.Daily Rate Calculations / Periods of Hire / Period of Hire Extensions/ Late Drop-off.The price of your car hire will be confirmed at time of booking and calculated on the basis of 24-hour units. If you wish to extend the period of hire after picking the car up, or if you drop the car off later than stated on your voucher / eVoucher, the contract for such an extension will always be with the car hire company directly and the extra time will be charged for by the car hire company at the local daily rate, which may be higher than the rates agreed with us at the time of booking. The car hire company may also charge an additional penalty for late drop-off, details of any additional payments will be in your contract with the car hire company.Late Pick-ups / Early Drop-offs.Your rental starts and finishes according to the pick-up and drop-off dates and times detailed on your voucher / eVoucher. Unfortunately, we are unable to provide refunds for unused time if a car is picked up late or dropped off early. If you are unable to pick the car up at the agreed time and date, it is essential you contact us as soon as possible. If you do not, there is no guarantee that the car will still be available – and you will not be entitled to any refund.One-Way Rentals.One-way rentals must be confirmed in advance and may be subject to one-way fees, payable to the car hire company. We will advise you of the approximate costs after we receive your booking request and receive confirmation from the car hire company regarding the one-way rental.Child Seats & Special Requests.Child seats, roof racks (not available on some cars) and other ‘extra’ items are available on request in most locations, although they cannot be guaranteed. There is usually a fee payable to the car hire company. In most locations, child seats are required by law. Please note: rear seatbelts may not be provided in all cars. Please check with our Contact Centre regarding these items. Requests for these items should be made at the time of booking.Deliveries & Collections.Some car hire companies will agree to deliver your car to / collect it from a specified address. If so, there may be a fee for this service, payable to the car hire company. We will advise you whether a fee will apply when you confirm your pick-up / drop-off times, along with the full address details, in your booking request.",
  RATING_BY_DRIVERS: "Rating given by drivers",
  ACCEPT: "Accept",
  PENDING_POPUP_CONTENT:
    "You may see a $1 pending charge on your bank statement as part of the card authorization process.This is a temporary authorization charge and it will disappear from your statement.Additional Information When storing customer details.Stripe sends a request to the issuing bank for either a $0 or a $1 authorization to verify that the card is valid and the bank will allow it to be authorized.Regardless of whether or not the authorization is declined, Stripe will reverse the authorization request immediately, but it may take 7-10 business days for the pending authorization to disappear from their bank statement.Stripe will first attempt a $0 authorization for Visa, MasterCard, and American Express card sources.If the $0 authorization fails, then a $1 authorization will be attempted.Other card types will begin with a $1 authorization.",
  CANCELLATION_POPUP_CONTENT:
    "After a relocation request has been made by the Driver and confirmed by the rental vehicle agency, a cancellation fee will apply if the Driver decides to cancel the booking or fail to collect the vehicle (no show). When the driver cancels the booking prior to 24hrs from the pickup date and time, a fee of NZD30 will apply. For bookings cancelled on the day of pickup (24hrs) or if the driver fails to collect the vehicle (no show), a fee of NZD150 will apply. These charges will be applied to the bank card the Driver has provided to us.Cancellations must be made on the Driver’s portal via the site.The driver also must notify the vehicle rental agency via email or phone.",
  SIGNUP_SUCCESS_MSG: `Thanks for signing up with EasyCarRelo - We are happy to have you here!
  We approve all agencies before it can go live on our website and we aim to have it done within hours from your submission. We thank you for your patience and we look forward to have you in our platform.`,
};
